
import Vue from 'vue'
import AppMixin from '@/_mixins/app'

import { HseContact } from '@/views/Project/HSE/types/hseContact'

import DialogTemplate from '@/_components/dialog/template/template.vue'
import { deleteHseContact } from '../../../../../../utils/hse'

const DeleteHseContactDialog = Vue.extend({
    mixins: [AppMixin],
    components: { DialogTemplate },

    props: {
        props: {
            type: Object as () => { hseContact: HseContact },
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            error: false as boolean | string,
        }
    },

    computed: {
        hseContact() {
            return this.props.hseContact
        },
    },

    methods: {
        async deleteHseContact() {
            this.loading = true

            try {
                await deleteHseContact(this.hseContact.id)
                this.$emit('close', true)
            } catch (error) {
                this.error = this.$t("hse_fe['settings.contacts.dialog_delete.error']").toString()
            } finally {
                this.loading = false
            }
        },
    },
})

export default DeleteHseContactDialog
